@if (isEditProjectLoading$ | async) {
  <app-page-loading></app-page-loading>
} @else {
  <div class="flex flex-1 h-full flex-col">
    <div
      class="font-semibold text-sm text-navy-600 pt-6 px-8 pb-10 w-full flex justify-between items-center box-border"
    >
      {{ isEdit ? 'Edit Project' : 'Add Project' }}
    </div>
    <div class="border-b border-solid border-navy-300 -mt-2"></div>

    <form class="flex flex-col h-full p-float-label flex-1 px-7 mt-5 overflow-hidden" #setupForm="ngForm">
      <ng-scrollbar #scrollbar appearance="native" class="std-scrollbar" orientation="vertical">
        <div [ngClass]="{ 'mr-3': scrollbar.isVerticallyScrollable() }">
          <app-floating-input
            [(ngModel)]="model.title"
            label="Title"
            name="title"
            placeholder="Title"
            required
          ></app-floating-input>

          <app-input-calendar
            [(date)]="model.start_date"
            [disabled]="false"
            [maxDate]="model.anticipated_completion_date"
            [minStartDate]=""
            [required]="true"
            [showIcon]="true"
            iconTooltip="Start date needs to be before or equal the anticipated date!"
            name="start_date"
            placeholder="Project Start Date"
            (dateChange)="startDateChanged($event)"
          ></app-input-calendar>

          <app-input-calendar
            [(date)]="model.anticipated_completion_date"
            [disabled]="false"
            [maxDate]="null"
            [minStartDate]="model.start_date"
            [required]="true"
            [showIcon]="true"
            name="anticipated_completion_date"
            placeholder="Completion Date"
          ></app-input-calendar>

          <app-floating-input
            [(ngModel)]="model.location"
            label="Location Name"
            name="location"
            placeholder="Location Name"
            required
          ></app-floating-input>

          <div class="grid grid-cols-2 gap-4">
            <app-floating-input
              [(ngModel)]="model.address"
              label="Address"
              placeholder="Address"
              name="address"
            ></app-floating-input>
            <app-floating-input
              [(ngModel)]="model.city"
              label="City"
              name="city"
              placeholder="City"
            ></app-floating-input>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <app-dropdown
              class="w-full"
              name="state"
              label="State"
              placeholder="State"
              [(ngModel)]="model.state"
              optionLabel="name"
              optionValue="abbreviation"
              [options]="states"
            >
            </app-dropdown>
            <app-floating-input
              [(ngModel)]="model.zip"
              label="ZIP Code"
              placeholder="ZIP Code"
              name="zip"
            ></app-floating-input>
          </div>

          <app-dropdown
            [(ngModel)]="model.status"
            [options]="projectStatuses"
            label="Project Status"
            name="status"
            optionLabel="name"
            optionValue="id"
            required
          >
            <ng-template #optionContent #selectedContent let-status>
              <div class="flex items-center gap-2">
                @if (status?.name) {
                  <span
                    [ngClass]="{
                      'bg-blue-600': status?.key === PROJECT_STATUS_KEY.IN_PROGRESS,
                      'bg-green-400': status?.key === PROJECT_STATUS_KEY.COMPLETED,
                      'bg-straw': status?.key === PROJECT_STATUS_KEY.PLANNED,
                      'bg-purple-700': status?.key === PROJECT_STATUS_KEY.CANCELED,
                      'bg-tinted-grey': status?.key === PROJECT_STATUS_KEY.ARCHIVED,
                      'bg-yellow-500': status?.key === PROJECT_STATUS_KEY.BIDDING,
                      'bg-green-600': status?.key === PROJECT_STATUS_KEY.AWARDED,
                      'bg-red-200': status?.key === PROJECT_STATUS_KEY.ON_HOLD,
                      'bg-color_cancel':
                        status?.key === PROJECT_STATUS_KEY.CANCELED || status?.key === PROJECT_STATUS_KEY.DELETED
                    }"
                    class="circle"
                  ></span>
                }
                <span class="capitalize">{{ status?.name }}</span>
              </div>
            </ng-template>
          </app-dropdown>

          <app-floating-input
            [(ngModel)]="model.custom_project_id"
            (inputBlurred)="customIdChanged($event)"
            [disabled]="!customIdEditable || !model.start_date"
            label="Project ID"
            placeholder="Project ID"
            name="custom_project_id"
            required
            [minLength]="3"
            [maxLength]="16"
            [iconClass]="!model.start_date ? '' : customIdEditable ? 'icon-text-revert' : 'icon-text-edit'"
            (iconClick)="onCustomIdIconClick()"
            [appTooltip]="!model.start_date ? 'Please select start date first.' : ''"
          ></app-floating-input>
        </div>
      </ng-scrollbar>
      <div class="flex items-center justify-between mb-7 mt-4 gap-4">
        @if (model?.id) {
          <div (click)="deleteProject()" class="delete-button" aria-hidden="true">Delete</div>
        }
        <button
          type="submit"
          (click)="saveClicked()"
          (keyup.enter)="saveClicked()"
          [ngClass]="{ 'bg-yellow-500 ml-auto': !model?.id, 'bg-blue-700': !!model?.id }"
          class="rounded text-color-white py-1 px-10 font-semibold text-sm cursor-pointer"
        >
          {{ !!model?.id ? 'Update' : 'Post' }}
        </button>
      </div>
    </form>
  </div>
}
